import { render } from "./YourData.vue?vue&type=template&id=3663ead5&scoped=true&ts=true"
import script from "./YourData.vue?vue&type=script&lang=ts"
export * from "./YourData.vue?vue&type=script&lang=ts"

import "./YourData.vue?vue&type=style&index=0&id=3663ead5&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3663ead5"]])

export default __exports__